import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DeviceService } from '@app/models/devices/devices.service';
import { LocationService } from '@app/models/locations/locations.service';
import { UserService } from '@app/models/users/users.service';
import { Notification } from '@app/models/notifications/notifications.model';
import { NbDialogService } from '@nebular/theme';
import { InfoDialogComponent } from '@app/shared/info-dialog/info-dialog.component';
import { CONSTANTS } from '@app/shared/constants';
import { BatteryOrder } from '@app/models/battery/battery-order.model';

@Component({
    selector: 'app-battery-notification',
    templateUrl: './battery.component.html',
    styleUrls: ['../notification-types.scss'],
})
export class BatteryNotificationComponent implements OnInit {
    @Input() notification: Notification = {} as Notification;
    @Output() markedRead = new EventEmitter();
    @Output() deleteNotification = new EventEmitter();
    deadBattery: boolean = false;
    constructor(
        private dialogService: NbDialogService,
        private locations: LocationService,
        private device: DeviceService,
        private user: UserService
    ) {}

    ngOnInit() {
        if (
            this.notification.extra &&
            this.notification.extra.problem &&
            this.notification.extra.problem === 'SENSOR_DEAD_BATTERIES'
        ) {
            this.deadBattery = true;
        }
    }

    orderBatteries() {
        this.locations
            .getCurrent()
            .pipe(this.device.joinLocationPipe())
            .subscribe((device) => {
                interface OrderBatteries {
                    link: string;
                    type: string;
                    price: string;
                }
                this.user.getPurchaseOptions(device.ws.id).subscribe((purchaseOptions: any) => {
                    const batteryOrder: OrderBatteries = purchaseOptions.find((option) => option.type === 'BATTERIES');
                    this.dialogService.open(InfoDialogComponent, {
                        context: {
                            title: 'Order Flume Batteries',
                            mode: 'battery-order',
                            helpLink: batteryOrder.link,
                            messages: [
                                {
                                    header: 'Click the link below to order batteries',
                                    message: `Flume batteries cost ${batteryOrder.price}. `,
                                },
                            ],
                        },
                    });
                });
            });
    }
}
